import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';

import { NotFound } from '@/components/Error/NotFound';
import ListPageHeader from '@/components/ListPageHeader';
import { ProductLogoMediumTimeAndAttendance } from '@/components/Logo';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_staff/attendances/_layout')({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.attendances',
  });
  useDocumentTitle(t('pageTitle'));

  const matchRoute = useMatchRoute();
  /** 打刻一覧の従業員詳細は `EmployeeClockingDetailHeader` があるためモジュールの ListPageHeader は出さない */
  const isEmployeeClockingDetail = matchRoute({
    to: '/attendances/clocking-records/$employeeId',
    fuzzy: true,
  });

  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }

  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col">
      {!isEmployeeClockingDetail ? (
        <ListPageHeader
          icon={<ProductLogoMediumTimeAndAttendance />}
          title={t('pageTitle')}
          tabs={[
            {
              to: '/attendances/overview',
              children: t('tabs.overview'),
              activeOptions: { exact: true },
            },
            {
              to: '/attendances/clocking-records',
              children: t('tabs.clockingRecords'),
              activeOptions: { exact: false },
            },
            {
              to: '/attendances/employees',
              children: t('tabs.employees'),
              activeOptions: { exact: false },
            },
            {
              to: '/attendances/alerts',
              children: t('tabs.alerts'),
              activeOptions: { exact: false },
            },
            {
              to: '/attendances/operation-activity',
              children: t('tabs.operationActivity'),
              activeOptions: { exact: false },
            },
            {
              to: '/attendances/rule-and-policy',
              children: t('tabs.ruleAndPolicy'),
              activeOptions: { exact: false },
            },
            {
              to: '/attendances/settings',
              children: t('tabs.settings'),
              activeOptions: { exact: false },
            },
          ]}
        />
      ) : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>
  );
}
